import { Stack, StackProps } from "@chakra-ui/react"

const TouchableOpacity: React.FC<StackProps> = (props) => {
    return <Stack
        cursor={'pointer'}
        onClick={() => { }}
        _hover={{ opacity: .8 }}
        _active={{ opacity: .3 }}
        {...props}
    />
}

export default TouchableOpacity;